export const getReturnMenuItemStyles = (_, { palette = {} }) => ({
  returnMenuItemContainer: {
    height: '36px',
  },
  returnMenuItem: {
    float: 'right',
    paddingLeft: '0 !important',
    display: 'flex',
    flexDirection: 'row',
    '& a': {
      padding: '8px 8px 9px 0px',
      height: '100%',
      width: '100%',
      color: palette.neutralPrimary,
      textAlign: 'right',
      lineHeight: '19px',
      fontSize: '14px',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      '&:focus': {
        textDecoration: 'none',
        outline: `1px solid ${palette.neutralSecondary}`,
        outlineOffset: -1,
      },
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'rgba(0, 0, 0, .1)',
      textDecoration: 'none',
    },
    '&:active': {
      backgroundColor: 'rgba(0, 0, 0, .2)',
      textDecoration: 'none',
    },
    '&:focus': {
      textDecoration: 'none',
    },
  },
  returnButtonIcon: {
    fontSize: '16px',
    lineHeight: '16px',
    padding: '0px 8px 0px 8px',
  },
});
